import { Box, Avatar, Typography, IconButton, Tooltip } from "@mui/material";

import { Timeline } from "@mui/lab";
import MapsUgcIcon from "@mui/icons-material/MapsUgc";
import ReplyIcon from "@mui/icons-material/Reply";

import Moment from "react-moment";
import moment from "moment";

import BookCommentBar from "./BookCommentBar";

import { useTranslation } from "react-i18next";
import { ImageUtils, UserUtils } from "../../utils";
import LikeDislikeReport from "./LikeDislikeReport";
import EditDelete from "./EditDelete";

import "../../assets/css/BookDetailsComments.css";

const BookComments = ({
  comments,
  onAddComment,
  onEditComment,
  onDeleteComment,
  onAddReply,
  onEditReply,
  onDeleteReply,
  onLikeComment,
  onDislikeComment,
  onLikeReply,
  onDislikeReply,
  onReportComment,
  onReportReply,
}) => {
  const { t } = useTranslation();
  const user = UserUtils.getUser();
  const commentsTitle = (text) => {
    return (
      <Box className="book-details-comments">
        <div className="line" />
        <div className="title">
          <Tooltip title={t("book.details.addComment")}>
            <IconButton aria-label="add-comment" onClick={onAddComment}>
              <MapsUgcIcon />
            </IconButton>
          </Tooltip>
          <Typography variant="h2" align="center">
            {text}
          </Typography>
        </div>
        <div className="line" />
      </Box>
    );
  };

  if (comments.length <= 0) {
    return commentsTitle(t("book.no_comments"));
  }

  return (
    <>
      {commentsTitle(t("book.comments"))}
      <Timeline className="w-full px-0 py-0">
        {comments.map((comment) => (
          <div className="flex flex-row justify-between items-center py-4 gap-6 border-slate-700 border-b-2" key={comment._id}>
            <div className="flex flex-col items-center">
              <Avatar alt={comment.author.name} src={ImageUtils.getMixedObjLocation(comment.author)} />
            </div>
            <div className="flex-1 px-0">
              <div className="flex flex-col md:flex-row justify-between md:items-center">
                <div className="flex flex-col">
                  <div className="flex flex-col">
                    <div className="flex flex-row items-center h-fit w-fit">
                      <Typography variant="h6">{comment.author.name}</Typography>
                      <IconButton onClick={() => onAddReply(comment)} disableRipple={true}>
                        <ReplyIcon />
                      </IconButton>
                    </div>
                    <Moment className="text-[14px] text-slate-300" fromNow>
                      {moment(comment.createdAt)}
                    </Moment>
                  </div>
                  <div>
                    <Typography className="break-words text-wrap">
                      {comment.content.split(" ").length === 1 ? comment.content.slice(0, 20) : comment.content}
                    </Typography>{" "}
                  </div>
                </div>
                <div className="flex flex-row gap-2 items-start">
                  <EditDelete
                    user={user}
                    item={comment}
                    author={comment.author}
                    onDelete={() => onDeleteComment(comment)}
                    onEdit={() => onEditComment(comment)}
                  />
                  <LikeDislikeReport
                    user={user}
                    item={comment}
                    author={comment.author}
                    onLike={() => onLikeComment(comment)}
                    onDislike={() => onDislikeComment(comment)}
                    onReport={() => onReportComment(comment)}
                  />
                </div>
              </div>
              {comment.replies.length > 0 && (
                <BookCommentBar
                  user={user}
                  comment={comment}
                  onEditReply={onEditReply}
                  onDeleteReply={onDeleteReply}
                  onLikeReply={(comment, reply) => onLikeReply(comment, reply)}
                  onDislikeReply={(comment, reply) => onDislikeReply(comment, reply)}
                  onReportReply={(comment, reply) => onReportReply(comment, reply)}
                />
              )}
            </div>
          </div>
        ))}
      </Timeline>
    </>
  );
};

export default BookComments;
